import moment from "moment";

export function isDate(obj) {
  return obj instanceof Date && Object.prototype.toString.call(obj) === '[object Date]';
}

export function datecmp(a, b, dateOnly = false) {
  if( moment.isMoment(a) ) a = a.toDate();
  if( moment.isMoment(b) ) b = b.toDate();

  if( !isDate(a) ) a = new Date(a);
  if( !isDate(b) ) b = new Date(b);

  if( dateOnly ) {
    a.setHours(0, 0, 0, 0);
    b.setHours(0, 0, 0, 0);
  }

  a = a.getTime();
  b = b.getTime();

  if( a === b ) {
    return 0;
  }
  else if( a > b ) {
    return 1;
  }
  else {
    return -1;
  }
}

export function daysCountWithoutWeekends(start, end) {
  if( moment.isMoment(start) ) start = start.toDate();
  if( moment.isMoment(end) ) end = end.toDate();

  if( !isDate(start) ) start = new Date(start);
  if( !isDate(end) ) end = new Date(end);

  let count = 0;
  let current = start;
  while (current <= end) {
      if( current.getDay() != 0 && current.getDay() != 6 ) ++count;
      var newDate = current.setDate(current.getDate() + 1);
      current = new Date(newDate);
  }
  return count;
}



// WEBPACK FOOTER //
// src/helpers/pleXpad.js